import {
    MlModelForLlmExecution,
    ModelOption,
} from "models/ModelCompute";
import BaseService from "./BaseService";

export interface HotWord {
    word: string;
}

interface GetActiveHotWordResponse {
    redaction: HotWord[];
    transcription: HotWord[];
}

interface SetHotWordsRequest {
    organizationId: string;
    transcriptionWords: string[];
    redactionWords: string[];
}

export interface GetLanguageDetectionHierarchiesResponse {
    organizationStructureMemberId: string;
}

export interface ModelControlProcessing {
    id: string;
    organizationId: string;
    processingOption: string;
}

export class ModelComputeService extends BaseService {
    protected urlBase = "api/ModelCompute";

    public async isModelOptionEnabled(modelOption: ModelOption) {
        return await this.get<boolean>(
            new URLSearchParams({ modelOption }),
            "IsModelOptionEnabled",
        );
    }

    public async getActiveHotWords(): Promise<GetActiveHotWordResponse> {
        const res = await this.get<GetActiveHotWordResponse>(
            new URLSearchParams({}),
            "GetActiveHotwords",
        );

        return res;
    }

    public async setHotwords(value: SetHotWordsRequest) {
        const res = await this.put(
            new URLSearchParams({}),
            "SetHotWords",
            JSON.stringify(value),
        );

        return res;
    }

    public async getLanguageDetectionHierarchies(): Promise<
        GetLanguageDetectionHierarchiesResponse[]
    > {
        const res = await this.get<GetLanguageDetectionHierarchiesResponse[]>(
            new URLSearchParams({}),
            "GetLanguageDetectionHierarchies",
        );

        return res;
    }

    public async setLanguageDetectionHierarchies(
        organizationStructureMemberIds: string[],
    ) {
        const res = await this.put(
            new URLSearchParams({}),
            "SetLanguageDetectionHierarchies",
            JSON.stringify({
                organizationStructureMemberIds,
            }),
        );

        return res;
    }

    public async getModelControlProcessing(): Promise<
        ModelControlProcessing[]
    > {
        const res = await this.get<ModelControlProcessing[]>(
            new URLSearchParams({}),
            "GetModelControlProcessing",
        );

        return res;
    }

    public async getActiveModelControlProcessingOptions(): Promise<
        ModelControlProcessing[]
    > {
        const res = await this.get<ModelControlProcessing[]>(
            new URLSearchParams({}),
            "GetActiveModelControlProcessingOptions",
        );

        return res;
    }

    public async setActiveModelControlProcessingOptions(
        modelControlProcessingOptionIds: string[],
    ) {
        await this.put(
            new URLSearchParams({}),
            "SetActiveModelControlProcessingOptions",
            JSON.stringify({
                modelControlProcessingOptionIds,
            }),
        );
    }

    public async getModelsForLlmExecution() {
        return this.get<MlModelForLlmExecution[]>(
            new URLSearchParams(),
            "MlModelsForLlmExecution",
        );
    }
}
